<div class="sg-telegram">
  @if (loading()) {
    <p class="muted">Loading…</p>
  } @else {
    @if (channel(); as c) {
    <div class="status-bar" [class.on]="c.is_active">
      <mat-icon inline>{{ c.is_active ? 'notifications_active' : 'notifications_off' }}</mat-icon>
      <span>
        {{ c.is_active ? 'Active — posting on schedule' : 'Inactive — nothing is sent' }}
      </span>
      <span class="spacer"></span>
      @if (c.last_sent_at) {
        <span class="muted">Last sent {{ c.last_sent_at | date: 'medium' }}</span>
      } @else {
        <span class="muted">Never sent</span>
      }
    </div>

    <div class="field">
      <label class="field-label">Telegram bot token</label>
      @if (c.has_bot_token) {
        <div class="muted token-state">
          <mat-icon inline>check_circle</mat-icon>
          Stored on the server, ending &middot;&middot;&middot;{{ c.bot_token_hint }}. Paste a new one
          to replace it.
        </div>
      } @else {
        <div class="muted token-state">
          <mat-icon inline>info</mat-icon>
          None stored — sending uses the server's own token, if it has one.
        </div>
      }
      <div class="options">
        <input
          type="password"
          class="token-input"
          autocomplete="off"
          placeholder="123456789:AA..."
          [(ngModel)]="tokenInput"
        />
        <button mat-stroked-button (click)="saveToken()" [disabled]="savingToken() || !tokenInput.trim()">
          {{ savingToken() ? 'Checking…' : 'Save token' }}
        </button>
        @if (c.has_bot_token) {
          <button mat-button (click)="saveToken(true)" [disabled]="savingToken()">Clear</button>
        }
      </div>
      <div class="muted">
        Checked against Telegram before saving — it must be an administrator of this channel with
        permission to post. The value is never shown again.
      </div>
    </div>

    <div class="field">
      <label class="field-label">Status</label>
      <div class="options">
        <button type="button" class="chip" [class.on]="c.is_active" (click)="setActive(true)">Active</button>
        <button type="button" class="chip" [class.on]="!c.is_active" (click)="setActive(false)">Inactive</button>
      </div>
    </div>

    <div class="field">
      <label class="field-label">Frequency</label>
      <div class="options">
        @for (f of ['daily', 'weekly', 'monthly']; track f) {
          <button type="button" class="chip" [class.on]="c.frequency === f" (click)="setFrequency($any(f))">
            {{ f | titlecase }}
          </button>
        }
      </div>
    </div>

    @if (c.frequency === 'weekly') {
      <div class="field">
        <label class="field-label">Days of the week</label>
        <div class="options">
          @for (d of weekdays; track d.value) {
            <button type="button" class="chip" [class.on]="isDaySelected(d.value)" (click)="toggleDay(d.value)">
              {{ d.label }}
            </button>
          }
        </div>
      </div>
    }

    @if (c.frequency === 'monthly') {
      <div class="field">
        <label class="field-label">Days of the month</label>
        <div class="options wrap">
          @for (d of monthDays; track d) {
            <button type="button" class="chip narrow" [class.on]="isDaySelected(d)" (click)="toggleDay(d)">
              {{ d }}
            </button>
          }
        </div>
        <div class="muted">Up to the 28th, so every month has that day.</div>
      </div>
    }

    <div class="field">
      <label class="field-label">Time (Singapore)</label>
      <div class="options">
        <input type="number" min="0" max="23" [value]="c.send_hour" (input)="setHour($any($event.target).value)" />
        <span class="colon">:</span>
        <input type="number" min="0" max="59" [value]="c.send_minute" (input)="setMinute($any($event.target).value)" />
      </div>
    </div>

    <div class="field">
      <label class="field-label">Products per send</label>
      <div class="options">
        <input type="number" min="1" max="50" [value]="c.product_count" (input)="setCount($any($event.target).value)" />
        <span class="muted">One message each, a few seconds apart.</span>
      </div>
    </div>

    <div class="field">
      <label class="field-label">Categories</label>
      <div class="options">
        @for (cat of categories; track cat.id) {
          <button type="button" class="chip" [class.on]="isCategorySelected(cat.id)" (click)="toggleCategory(cat.id)">
            {{ cat.label }}
          </button>
        }
      </div>
      <div class="muted">
        Only active, in-stock products from active sellers in the {{ c.iso2 }} market, newest first,
        skipping anything already posted.
      </div>
    </div>

    <div class="actions">
      <button mat-raised-button color="primary" (click)="save()" [disabled]="saving() || !!validationError()">
        {{ saving() ? 'Saving…' : 'Save' }}
      </button>
      <button mat-stroked-button (click)="loadPreview()" [disabled]="busy()"
              matTooltip="List what the next run would post, without posting it">
        Preview
      </button>
      <button mat-stroked-button (click)="sendNow()" [disabled]="busy()"
              matTooltip="Post now, for real, ignoring the schedule">
        Send now
      </button>
    </div>

    @if (validationError()) {
      <div class="error">{{ validationError() }}</div>
    }
    @if (message()) {
      <div class="muted">{{ message() }}</div>
    }
    @if (error()) {
      <div class="error">{{ error() }}</div>
    }

    @if (preview(); as list) {
      <div class="preview">
        <div class="field-label">Next run would post {{ list.length }} product(s)</div>
        @if (!list.length) {
          <div class="muted">Nothing new — every recent product has already been posted.</div>
        }
        <ol>
          @for (p of list; track p.id) {
            <li>{{ p.name }} @if (p.price) { <span class="muted">— {{ p.price }}</span> }</li>
          }
        </ol>
      </div>
    }
    } @else if (error()) {
      <div class="error">{{ error() }}</div>
    }
  }
</div>
